define([
	"dojo/_base/declare",
	"Apparel/ProductType",
	"csi/locale"
], function(declare, ProductType, locale) {

	return declare(null, {
		bColorContext: false,
		bSampleContext: false,

		_hideFields: function(/*csi.def.View*/defView, cache, parent) {
			var fGroup = defView.getField("TestSpecGroup");
			var fColor = defView.getField("TestRunColor");
			var fSample = defView.getField("TestRunSample");

			if (fGroup) fGroup.bHidden = true;

			parent = parent || this.getParent();

			const parentType = parent.$Type;
			if (parentType == "QualityAdmin") {
				// New Template
				if (fColor) fColor.bHidden = true;
				if (fSample) fSample.bHidden = true;
			} else if ((parentType == "Material" || parentType == "Style") && !ProductType.hasColor(parent)) {
				if (fColor) fColor.bHidden = true;
			} else if (parentType == "Food" || parentType == "FormulatedMaterial") {
				if (fColor) fColor.bHidden = true;
			}
		},

		_disableColorOrSample: function(/*csi.view.Widget*/view) {
			// summary: set fixed value for color/sample in template copy form - be careful that we are processing
			// the form view rather than the NewFrom table that appears before the form
			if (view.addFixedValue && (this.bColorContext || this.bSampleContext)) {
				var colorOrSample = this.getParent();

				view.cacheView.cacheNode(colorOrSample);
				view.addFixedValue(this.bColorContext ? "TestRunColor" : "TestRunSample", colorOrSample.$URL);

				// trick csi.form.Widget.getFormNode into using Product as parent, not ProductColor/Sample
				var path = (colorOrSample.$Type.indexOf("ample") != -1)
					? "Child:__Parent__/Child:__Parent__/Child:__Parent__"
					: "Child:__Parent__";
				this.m_formData.m_parentNode = this.m_cache.getPathNode(colorOrSample, path, true);
			}
		},

		/**
		 * use return value for Count TestRun
		 */
		getRecordCount: function() {
			let cntr = 0;
			const {bCanCreateMultipleTestRuns, newTestRuns} = this.popupView;
			if (bCanCreateMultipleTestRuns) {
				cntr = newTestRuns == null ? 0 : newTestRuns.length;
			} else {
				cntr = this.m_urlNode == null ? 0 : 1;
			}
			return cntr;
		},

		/**
		 * @override
		 * use return value for display TestRun progress message
		 */
		getResourceForRecordCountType: function(resSuffix) {
			const count = this.getRecordCount();
			const testRun_s = (count == 1) ? locale.type("TestRun") : locale.typePlural("TestRun");
			return locale.resource("NewTestRunFrom_" + resSuffix, [count, testRun_s]);
		},

		/**
		 * @override
		 * use return value as parameter for display progress message
		 */
		getMessage: function() {
			return this.getResourceForRecordCountType("Message");
		},

		/**
		 * @override
		 * use return value as parameter for display Error message
		 */
		getError: function() {
			return this.getResourceForRecordCountType("Error");
		},

		/**
		 * @override
		 * use return value as parameter for display Success message
		 */
		getSuccess: function() {
			return this.getResourceForRecordCountType("Success");
		}
	});
});
